module.exports = __webpack_public_path__ + "static/media/overview-selected.d15e559a.svg";